export default "__VITE_ASSET__Dp_NM3yU__"